// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"filters_filtersWrapper__xhAew"};